import { createSelector } from 'reselect'
import { AppState } from 'Store'

const selectContractEntries = (state: AppState) =>
	state.advertisement.contract.contract_list.entries
const selectContractList = (state: AppState) => state.advertisement.contract.contract_list
const selectTotal = (state: AppState) => state.advertisement.contract.contract_list.total_entries
const selectContract = (state: AppState) => state.advertisement.contract.contr
const selectCurrentParams = (state: AppState) => state.advertisement.contract.requestParams
const selectContr = (state: AppState) => state.advertisement.contract.openedContr
const selectDict = (state: AppState) => state.advertisement.organization.dict

const selectContractKinds = createSelector(selectDict, (dict) => dict.contracts?.kinds)
const selectContractActions = createSelector(selectDict, (dict) => dict.contracts?.action_types)

const selectContractSubject = createSelector(selectDict, (dict) => dict.contracts?.subject_types)

const getContrId = createSelector(selectContractList, (contr) => {
	return {
		...contr,
		entries: contr.entries.map((contr) => ({
			...contr,
			id: contr.id,
			name: `${contr.number} (${contr.contractor.inn}-${contr.contractor.name})`,
		})),
	}
})

export const contractSelector = {
	selectContractEntries,
	selectContractList,
	selectContract,
	selectCurrentParams,
	selectTotal,
	selectContr,
	selectContractActions,
	selectContractSubject,
	selectContractKinds,
	getContrId,
}
